import { atom, useAtom } from "jotai";
import { useCallback } from "react";
import { applyTheme, persistTheme, resolveTheme, type Theme } from "./theme-core";

export type { Theme } from "./theme-core";
export { THEMES, applyTheme } from "./theme-core";

export const getStoredTheme = resolveTheme;

// Initialised from the same resolver the no-flash boot script already ran.
export const themeAtom = atom<Theme>(resolveTheme());

export const useTheme = () => {
  const [theme, setThemeState] = useAtom(themeAtom);

  const setTheme = useCallback(
    (next: Theme) => {
      setThemeState(next);
      persistTheme(next);
      applyTheme(next);
    },
    [setThemeState],
  );

  return { theme, setTheme };
};
